module.exports = __webpack_public_path__ + "static/media/trends_logo.09ea3e24.png";